import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Modal from 'components/Tvendo/Common/ModalBase';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default function ModalBTurn(props) {
  const bTurn = props.model;
  const { bPartners } = props;

  const [dataChanging, setDataChanging] = useState(bTurn);

  function handleChange(field, value) {
    setDataChanging({
      ...dataChanging,
      [field]: value,
    });
  }

  return (
    <Modal
      title="Giros de negocio"
      model={bTurn}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      entity="base/business-line"
      state
    >
      <TextField
        label="Código"
        fullWidth
        type="text"
        name="code"
        margin="normal"
        defaultValue={bTurn.code || ''}
        required
      />
      <TextField
        label="Descripción"
        fullWidth
        type="text"
        name="description"
        margin="normal"
        defaultValue={bTurn.description || ''}
        required
      />
      <Autocomplete
        disableClearable
        options={bPartners}
        getOptionLabel={(option) => option.CardName}
        defaultValue={
          !!bTurn
            ? bPartners.find((bPartner) => bPartner.id == bTurn.base_business_partner_id)
            : undefined
        }
        renderInput={(params) => (
          <TextField {...params} label="Socio Negocio / Proveedor" margin="normal" required />
        )}
        onChange={(e, item) => {
          if (!!item) handleChange('base_business_partner_id', item.id);
        }}
      />

      <FormControl fullWidth margin="normal" size="small" required>
        <InputLabel>Incluir en config. promoción</InputLabel>
        <Select defaultValue={bTurn.promotion_list || 'N'} inputProps={{ name: 'promotion_list' }}>
          <MenuItem value="Y">Si</MenuItem>
          <MenuItem value="N">No</MenuItem>
        </Select>
      </FormControl>
    </Modal>
  );
}
